import { useMutation, useQueryClient } from "@tanstack/react-query";
import * as Sentry from "@sentry/react";
import toast from "react-hot-toast";
import { supabase } from "../../lib/supabase";
import { queryKeys } from "../../lib/queryKeys";
import { AgentConnection } from "../../types";

/**
 * Turns a connection off. The row stays, marked revoked, so the assistant's
 * sign-in keeps failing from then on rather than one day working again.
 */
export function useRevokeAgentConnection() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: string): Promise<string> => {
      const { error } = await supabase
        .from("agent_connections")
        .update({ revoked_at: new Date().toISOString() })
        .eq("id", id);
      if (error) throw error;
      return id;
    },

    onSuccess: (id) => {
      queryClient.setQueryData<AgentConnection[]>(
        queryKeys.agentConnections,
        (old) => (old ?? []).filter((connection) => connection.id !== id),
      );
    },

    onError: (err) => {
      Sentry.captureException(err, {
        extra: { mutation: "useRevokeAgentConnection" },
      });
      toast.error("Could not turn off the connection. Please try again.");
    },
  });
}
